import { t } from '@lingui/macro';
import { PackType } from 'types/enums';

export const getViewCtaCopy = (type: PackType) => {
    let copy;

    switch (type) {
        case PackType.Pack:
            copy = t`View full pack`;
            break;

        case PackType.RePack:
            copy = t`View full collection`;
            break;
    }

    return copy;
};
